
var animationEnd = 'webkitAnimationEnd oanimationend msAnimationEnd animationend';

var FadeTransition = Barba.BaseTransition.extend({
    start: function() {
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },
  
    fadeOut: function() {
      var deferred = Barba.Utils.deferred();
      var el = this.oldContainer;

      $(el).addClass('transition transition--out');
      $(el).one(animationEnd,function() {
        deferred.resolve();
      });

      return deferred.promise;
    },
  
    fadeIn: function() {
      var deferred = Barba.Utils.deferred();
      var el = this.newContainer;
      var _this = this;
      $(el).css('visibility','visible');
      $(this.oldContainer).hide();
      $(window).scrollTop(0);
      $(el).addClass('transition transition--in');
      $(el).one(animationEnd,function() {
        $(el).removeClass('transition transition--in');
        _this.done();
        deferred.resolve();
      });

      return deferred.promise;
    }
  });
  
  /**
   * Next step, you have to tell Barba to use the new Transition
   */
  
  Barba.Pjax.getTransition = function() {
    /**
     * Here you can use your own logic!
     * For example you can use different Transition based on the current page or link...
     */
  
    return FadeTransition;
  };